import styles from './Loading.module.css';

interface LoadingProps {
  size?: number;
  color?: string;
  fade?: boolean;
}

export default function Loading({ size = 60, color = 'var(--color-accent)', fade = false }: LoadingProps) {
  const sizePx = `${size}px`;
  const overlayClass = fade ? `${styles.overlay} ${styles.hide}` : styles.overlay;

  return (
    <div className={overlayClass} role="status" aria-live="polite">
      <div
        className={styles.spinner}
        style={{ width: sizePx, height: sizePx, borderTopColor: color }}
      />
    </div>
  );
}
